import {
  twoDigitNum,
  timeFromDate,
  selectDay,
  selectMonth,
  isCmsImage,
  cmsImageBaseUrlV2,
} from '../helpers';
import {
  CATCH_UP_AFTERNOON_TIME,
  CATCHUP_EVENING_TIME,
  CATCH_UP_MORNING_TIME,
  FEED_URLSRC_CMS_V2,
  API_ROOT_IMG_STAGE_CMS_V2,
} from '../constants';
import {
  FETCH_CATCHUP_DAYS,
  FETCH_CATCHUP_DAY,
  CATCHUP_DAY_IS_LOADING,
  CATCHUP_DAY_HAS_ERRORED,
  FETCH_CATCHUP_FEATURE,
  CATCHUP_FEATURE_IS_LOADING,
  CATCHUP_FEATURE_HAS_ERRORED,
} from './types';
import { uiStrings } from './ui_strings';
import { globalFetch } from './globalActions';
import { localStorageLang } from '../constants';

//////////////
// Catch up //
//////////////

function catchUpTodaysDateFormat(date) {
  let dateString;
  if (!date || date === '') {
    const currentDate = new Date();
    dateString = `${currentDate.getFullYear()}-${twoDigitNum(
      currentDate.getMonth() + 1
    )}-${twoDigitNum(currentDate.getDate())}`;
  } else {
    dateString = date;
  }

  return dateString;
}

/* Get the last 35 days dates for the date slider on ther Catchup page */
export function fetchCatchupDays() {
  const lang =
    localStorage.getItem(localStorageLang) === null
      ? 0
      : parseInt(localStorage.getItem(localStorageLang), 10);
  let dates = [],
    date = new Date(),
    itemDate;
  for (var i = 0; i < 35; i++) {
    itemDate = new Date();
    itemDate.setDate(date.getDate() - i);
    let dayString = selectDay(lang, itemDate.getDay());
    dayString =
      i === 0
        ? uiStrings[lang].today
        : i === 1
        ? uiStrings[lang].yesterday
        : dayString;
    dates.push({
      day: dayString,
      date: itemDate.getDate() + ' ' + selectMonth(lang, itemDate.getMonth()),
      date_url: `${itemDate.getFullYear()}-${twoDigitNum(
        itemDate.getMonth() + 1
      )}-${twoDigitNum(itemDate.getDate())}`,
    });
  }

  return {
    type: FETCH_CATCHUP_DAYS,
    payload: dates.reverse(),
  };
}

/* Get the selected dates programmes */
export function fetchCatchupDay(date) {
  const dateURL = catchUpTodaysDateFormat(date);
  return globalFetch({
    urlPath: `listings_for_date`,
    extraParams: `&date=${dateURL}`,
    reducerIsLoading: CATCHUP_DAY_IS_LOADING,
    reducerError: CATCHUP_DAY_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(catchupDaySuccess(itemObj));
    },
  });
}

/*
  Work out whether a listings_for_date item can be watched on Clic.

  available_on_clic is the feed's explicit boolean and matches the separate
  check_avail endpoint, so use it whenever it is present.

  Older feeds only have `available`, which is a link string:
  - 'programme_id=…' when the programme can be watched
  - 'series_id=…' when only the series page exists
  - null, or now an empty string, when nothing is available
  The empty string must be treated as unavailable, otherwise the item is
  rendered as a link to /programme/ with no id.
*/
function isListingAvailable(value) {
  if (typeof value.available_on_clic === 'boolean') {
    return value.available_on_clic;
  }

  return !!value.available && !value.available.includes('series_id');
}

export function catchupDaySuccess(items) {
  let itemsContained = [],
    itemsFeed = {};
  if (items.listings_for_date.length > 0) {
    let containerId = 0,
      value,
      valDate,
      itemContained = {},
      title,
      sTitle,
      pTitle;
    let nextProg = 0;
    for (let i = 0; i < items.listings_for_date.length; i++) {
      value = items.listings_for_date[i];
      valDate = new Date(value.date_broadcast.replace(/-/g, '/'));
      sTitle =
        value.series_title && value.series_title !== null
          ? value.series_title
          : '';
      pTitle =
        value.programme_title && value.programme_title !== null
          ? value.programme_title
          : '';

      if (sTitle && pTitle) {
        title =
          sTitle.trim().toLowerCase() === pTitle.trim().toLowerCase()
            ? `${sTitle}`
            : `${sTitle} - ${pTitle}`;
      } else {
        title = `${sTitle} ${pTitle}`;
      }

      if (
        value.container === 'Y' ||
        ((value.container === 'N' || value.container == null) &&
          (value.contained === 'N' || value.contained === null))
      ) {
        itemsContained[containerId] = {
          title: title,
          time: timeFromDate(valDate),
          hour: valDate.getHours(),
          thumbnail: value.thumbnail_url,
          programme_id: value.id,
          short_billing: value.short_billing,
          isContainer: value.container === 'Y' ? true : false,
          available: isListingAvailable(value),
          duration: value.duration,
          programmes: [],
          b888: value.b888,
          b889: value.b889,
          b_audio_described: value.b_audio_described,
          b_visually_signed: value.b_visually_signed,
        };

        nextProg = value.id;
        containerId++;
      }

      if (
        value.container === 'Y' ||
        ((value.container === 'N' || value.container === null) &&
          value.contained === 'Y')
      ) {
        if (nextProg !== value.id) {
          itemContained = {
            programme_title:
              value.programme_title === ''
                ? value.series_title
                : value.programme_title,
            series_title: value.series_title,
            clic_aired: value.date_broadcast,
            id: value.id,
            programme_id: value.id,
            short_billing: value.short_billing,
            thumbnail: value.thumbnail_url,
            duration: value.duration,
            isContainer: value.container === 'Y' ? true : false,
            end_dt: value.end_dt,
            title: title,
            time: timeFromDate(value.date_broadcast.replace(/-/g, '/')),
            episode_num: value.episode_num,
            available: isListingAvailable(value),
            b888: value.b888,
            b889: value.b889,
            b_audio_described: value.b_audio_described,
            b_visually_signed: value.b_visually_signed,
          };

          if (itemsContained[containerId - 1]) {
            itemsContained[containerId - 1].programmes.push(itemContained);
          }
        }
      }
    }

    let morning = [],
      afternoon = [],
      evening = [];
    Object.entries(itemsContained).forEach(([key, value]) => {
      if (
        value.hour >= CATCH_UP_MORNING_TIME &&
        value.hour < CATCH_UP_AFTERNOON_TIME
      ) {
        morning.push(value);
      } else if (
        value.hour >= CATCH_UP_AFTERNOON_TIME &&
        value.hour < CATCHUP_EVENING_TIME
      ) {
        afternoon.push(value);
      } else if (
        value.hour >= CATCHUP_EVENING_TIME ||
        value.hour < CATCH_UP_MORNING_TIME
      ) {
        evening.push(value);
      }
    });

    itemsFeed = {
      day: { morning: morning, afternoon: afternoon, evening: evening },
    };
  }

  return {
    type: FETCH_CATCHUP_DAY,
    payload: items.listings_for_date.length > 0 ? itemsFeed.day : {},
  };
}

/* Get the Pic of the Days on Catchup page */
export function catchUpFeature(date) {
  return globalFetch({
    urlPath: 'highlights',
    extraParams: `&broadcastDate=${catchUpTodaysDateFormat(date)}`,
    urlSrc: FEED_URLSRC_CMS_V2,
    reducerIsLoading: CATCHUP_FEATURE_IS_LOADING,
    reducerError: CATCHUP_FEATURE_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(catchUpFeatureSuccess(itemObj, date));
    },
  });
}

export function catchUpFeatureSuccess(items, date) {
  let results = [],
    progThumbnail = '';
  if (items.results && Object.keys(items.results).length > 0) {
    Object.entries(items.results).forEach(([key, value]) => {
      progThumbnail =
        value.image &&
        isCmsImage(value.image.url) &&
        !value.image.path.includes('media_assets/') &&
        cmsImageBaseUrlV2() === API_ROOT_IMG_STAGE_CMS_V2
          ? 'media_assets/' + value.image.path
          : value.image.path;
      results[key] = {
        id: value.programme.programmeId,
        title: value.preTitle,
        subTitle: value.title,
        thumbnail: progThumbnail,
        isCMSThumbnail: isCmsImage(value.image.url),
        isActions: true,
        available: true,
      };
    });
  }

  return {
    type: FETCH_CATCHUP_FEATURE,
    payload: results,
  };
}
